import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { ASSIGMENTS_API } from "@constants/api";
import { AlertResultApi } from "@utils/alert";

export const initialStateAssigment = {
  fetching: "done",
};

export const Assigment = types
  .model({
    fetching: types.string,
    status: types.maybeNull(types.number),
  })
  .actions((self) => ({
    getAssigment: flow(function* (
      assignmentId: number,
      token: string,
      callback: (data: lastLocationType) => void
    ) {
      self.fetching = "pending";
      self.status = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "get",
          url: `${ASSIGMENTS_API}/${assignmentId}/lastLocation`,
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(result);
        callback(result.data);
        self.fetching = "done";
      } catch (error) {
        // ... including try/catch error handling
        self.fetching = "error";
        self.status = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
  }));
